// extracted by mini-css-extract-plugin
export default {"recos":"c4-z","productCardOverride":"d4-z","rowHasBadge":"e4-z"};